import { ExternalToast, toast, Toaster } from 'sonner';
import { v4 as uuidv4 } from 'uuid';
import { ToasterMessage, ToasterMessageProps } from './ToasterMessage';
import { Severity } from './types';

const DEFAULT_TIMEOUT = 6000;

const renderComponent =
  (severity: Severity) =>
  (
    {
      title,
      onClose,
      toastActions,
      id = uuidv4(),
    }: Omit<ToasterMessageProps, 'severity'>,
    options?: ExternalToast
  ) => {
    const dismissible = options?.dismissible ?? true;
    toast.custom(
      toastId => (
        <ToasterMessage
          severity={severity}
          title={title}
          toastActions={toastActions}
          onClose={
            dismissible
              ? () => {
                  onClose?.();
                  toast.dismiss(toastId);
                }
              : undefined
          }
        />
      ),
      {
        id,
        duration: DEFAULT_TIMEOUT,
        ...options,
      }
    );
  };

export const notify = {
  default: renderComponent('default'),
  error: renderComponent('error'),
};

export const ToasterContainer = () => (
  <Toaster
    position="bottom-center"
    style={{ width: 600, display: 'flex', justifyContent: 'center' }}
  />
);
